// extracted by mini-css-extract-plugin
export default {"link":"styles_link__IU67o","external":"styles_external__sGnm7","activeItem":"styles_activeItem__zjvJU","fillIcon":"styles_fillIcon__TAK7H","count":"styles_count__yxe0c"};